import { Component, signal } from '@angular/core';
import { FServiceService } from '../../../Services/FService/f-service.service';
import { FSharedServiceService } from '../../../Services/FService/f-shared-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-f-first-selection',
  templateUrl: './f-first-selection.component.html',
  styleUrl: './f-first-selection.component.css'
})
export class FFirstSelectionComponent {
  scrollToCommonSecondComponent() {
    const hpSecondComponent = document.querySelector('app-second-selection');
    if (hpSecondComponent) {
      hpSecondComponent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
  constructor(private fSharedService:FSharedServiceService, private fService:FServiceService,private router:Router){}
  specData:any={};
  modifiedSize:any;
  userSelectedData:any={};
  sizeSpeedRatio:any={
    size:"",
      ratio:"",
      speed:"",
      inputPower:"",
      units:""
  };
  public showspinfo: boolean = false;
  public showcdinfo: boolean = false;
  ngOnInit(){
    const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
    this.signalStatus=true;
    this.panelOpenState = signal(this.signalStatus);
    this.fSharedService.specification$.subscribe((specificationData:any) => 
      {
        this.sizeSpeedRatio.size = specificationData.Size;
      this.sizeSpeedRatio.ratio = specificationData.Ratio;
      this.sizeSpeedRatio.speed = specificationData.Speed;
        this.specData = {
          Size: specificationData.Size,
          Ratio: specificationData.Ratio,
          Speed: specificationData.Speed,
          InputPower_Imp: specificationData.InputPower_Imp=="N/A"?specificationData.InputPower_Imp:specificationData.InputPower_Imp+" HP",
          InputPower_Met: specificationData.InputPower_Met=="N/A"?specificationData.InputPower_Met:specificationData.InputPower_Met+" kW",
          InputTorque_Imp: specificationData.InputTorque_Imp,
          InputTorque_Met: specificationData.InputTorque_Met,
          InputTorque_Acc_Imp: specificationData.InputTorque_Acc_Imp,
          InputTorque_Acc_Met: specificationData.InputTorque_Acc_Met,
          InputPower_Ther_Imp: specificationData.InputPower_Ther_Imp=="N/A"?specificationData.InputPower_Ther_Imp:specificationData.InputPower_Ther_Imp+" HP",
          InputPower_Ther_Met: specificationData.InputPower_Ther_Met=="N/A"?specificationData.InputPower_Ther_Met:specificationData.InputPower_Ther_Met+" kW",
          OutputTorque_Imp: specificationData.OutputTorque_Imp=="N/A"? specificationData.OutputTorque_Imp:specificationData.OutputTorque_Imp+" lb-in",
          OutputTorque_Met: specificationData.OutputTorque_Met=="N/A"? specificationData.OutputTorque_Met:specificationData.OutputTorque_Met+" Nm",
          OutputTorque_Acc_Imp: specificationData.OutputTorque_Acc_Imp,
          OutputTorque_Acc_Met: specificationData.OutputTorque_Acc_Met,
          EFF: specificationData.EFF=="N/A"?specificationData.EFF:specificationData.EFF+" %",
          Reduction: specificationData.Reduction,
          specServiceFactor:specificationData.specServiceFactor
        };
        this.modifiedSize = this.specData.Size.substring(2,4);
        console.log("F Modified Size is: ", this.modifiedSize);
        const specSFElements = document.getElementsByClassName('sericeFactorStyle');
          for (let i = 0; i < specSFElements.length; i++) {
            const element = specSFElements[i] as HTMLElement;
            if (Number(specificationData.specServiceFactor) < Number(this.userSelectedData.SelectedServiceFactor)) {
                element.style.setProperty('background-color', '#dc3545', 'important');
            } else {
                element.style.setProperty('background-color', '#28a745', 'important');
            }
          }
      });
      this.fSharedService.getFormData().subscribe(data => {
        this.sizeSpeedRatio.inputPower = data.selectedInputPower;
        this.sizeSpeedRatio.units = data.selectedUnits;
        this.userSelectedData={
          SelectedInputPower:data.selectedInputPower || "Null",
          SelectedUnits:data.selectedUnits || "Null",
          SelectedSpeed:data.selectedSpeed || "Null",
          SelectedRatio:data.selectedRatio || "Null",
          SelectedDutyCycle:data.selectedDutyCycle || "Null",
          SelectedServiceFactor:data.selectedServiceFactor || "Null",
          SelectedOutputSpeed:data.selectedOutputSpeed || "Null"
        };
      });
  }
  largerReducer():void{
    const parameters={
      size:this.sizeSpeedRatio.size,
      speed:this.sizeSpeedRatio.speed,
      ratio:this.sizeSpeedRatio.ratio,
      Inputpower_Them : this.sizeSpeedRatio.inputPower,
      units: this.sizeSpeedRatio.units
    };
    this.fService.getLargerReducer(parameters).subscribe(result => {
      debugger;
          if(result.body==null){
        alert("No Larger Size available")
      }else
      {
        this.fSharedService.setSpecification(result.body);
      }
    });
  
  }
  smallerReducer():void{
    const parameters={
      size:this.sizeSpeedRatio.size,
      speed:this.sizeSpeedRatio.speed,
      ratio:this.sizeSpeedRatio.ratio,
      Inputpower_Them : this.sizeSpeedRatio.inputPower,
      units: this.sizeSpeedRatio.units
    };
    this.fService.getSmallerReducer(parameters).subscribe(result => {
      if(result.body==null){
        alert("No Smaller Size available")
      }else
      {
        this.fSharedService.setSpecification(result.body);
      }
    });
  
  }
  reducerFeature():void{
    this.fSharedService.setSize(this.sizeSpeedRatio);
  }
}
